import $ from "jquery";
import Swiper from "swiper";

import SwiperCore, { Pagination, Autoplay, EffectFade } from "swiper/core";

import "swiper/swiper-bundle.css";

$(function () {
  // configure Swiper to use modules
  SwiperCore.use([Pagination, EffectFade, Autoplay]);
  new Swiper(".swiper-container", {
    // Optional parameters
    //spaceBetween: 30,
    //loop: true,
    effect: "fade",
    speed: 2000,
    fadeEffect: {
      crossFade: true,
    },

    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },

    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
});
